export default "__VITE_ASSET__eDMNQ1BL__"